import React from 'react';
import PropTypes from 'prop-types';
import CwTriggerField from '../cwtriggerfield/CwTriggerField';
import { IsEmpty } from '../../utils/ValidationUtils';

class CwPickerField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayText: '',
    };
  }

  componentDidMount() {
    // Display value's name if already given one when pickerfield re-mounts (i.e. after pod collapses then re-expands)
    if (this.props.value) {
      this.setState({
        displayText: this.props.value[this.props.nameField] ? this.props.value[this.props.nameField] : this.props.value
      });
    }

    if (this.props.onComponentDidMount) {
      this.props.onComponentDidMount();
    }
  }

  componentWillReceiveProps(nextProps) {
    const nameField = nextProps.nameField ? nextProps.nameField : this.props.nameField;
    // Display value's name if receiving it from the parent
    if (nextProps.value && (nextProps.value[nameField] !== undefined)) {
      this.setState({
        displayText: nextProps.value[nameField]
      });
    }
    else {
      this.setState({
        displayText: ''
      });
    }

    if (this.props.onComponentWillReceiveProps) {
      this.props.onComponentWillReceiveProps(nextProps);
    }
  }

  handleInputFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }

  handleInputBlur = () => {
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  handleChange = (enteredText) => {
    this.setState({
      displayText: enteredText,
    });
    if (IsEmpty(enteredText)) {
      this.props.onChange(null);
    }
  };

  isValueIncomplete = () => {
    const valueText = this.props.value ? this.props.value[this.props.nameField] : '';

    return valueText !== this.state.displayText;
  };

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handlePicker();
    }
    else if (event.key === 'Tab' && this.isValueIncomplete()) {
      this.handlePicker();
    }
  }

  handlePicker = () => {
    if (this.props.disabled) {
      return;
    }

    if (this.props.onPicker) {
      this.props.onPicker(this.isValueIncomplete() ? this.state.displayText : '');
    }

    this.focus();
  };

  focus() {
    this.cwTriggerField.focus();
  }

  render() {
    return this.props.field ?
      (this.props.field)
      :
      (
        <CwTriggerField
          cwId={this.props.cwId}
          triggerIcon={this.props.pickerIcon}
          autoComplete="off"
          ref={(input) => this.cwTriggerField = input}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          value={this.state.displayText}
          disabled={this.props.disabled}
          invalid={this.props.invalid}
          readOnly={this.props.readOnly}
          onTrigger={this.handlePicker}
          className={this.props.className}
          customElement={this.props.customElement}
          autoFocus={this.props.autoFocus}
          placeholder={this.props.placeholder}
        />
      );
  };
}

CwPickerField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Path to picker icon
   */
  pickerIcon: PropTypes.string,
  /**
   * Callback function that is fired when picker field's text changes
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired on picker field focus
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired on picker field blur
   */
  onBlur: PropTypes.func,
  /**
   * Callback function that is fired when picker is clicked on
   */
  onPicker: PropTypes.func,
  /**
   * Used to control if picker field is valid
   */
  invalid: PropTypes.bool,
  /**
   * Used to disable picker field
   */
  disabled: PropTypes.bool,
  /**
   * Text in textfield
   */
  value: PropTypes.any,
  /**
   * Used to add custom css
   */
  className: PropTypes.string,
  /**
   * Used to set input field to readonly
   */
  readOnly: PropTypes.bool,
  /**
   * Used to control if input field is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * Used to add a custom element to the left side of the picker field
   */
  customElement: PropTypes.any,
  /**
   * The name of the field where text can be displayed. Will default to name
   */
  nameField: PropTypes.string,
  /**
   * Alternative component to use for the text field
   */
  field: PropTypes.object,
  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: PropTypes.string
};

CwPickerField.defaultProps = {
  nameField: 'name',
};

export default CwPickerField;


// WEBPACK FOOTER //
// ./src/components/cwpickerfield/CwPickerField.jsx